import React, { useState, useCallback } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { ScreeningPendingReview } from '@scale/shared/taskerScreening/types';
import { ScreeningReviewQualificationSectionStatus } from '@scale/shared/types/qualification/types';
import { Button } from '@scale/scaleui';
import TaskerScreeningGradingReviewModal from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningGradingReviewModal';
import API from '@scale/frontend-lib/dashboard-api';
import { defaultWorkerSkillDimension } from '@scale/shared-types';

interface TaskerScreeningBenchmarkCreationToolProps {
  user: IUserJson;
  setNeedsFetch: (needsFetch: boolean) => void;
}

export const questionPlaceholder = 'Here is a sample question!';
export const answerPlaceholder = 'Here is a sample answer!';

export const defaultBenchmark: ScreeningPendingReview = {
  _id: '',
  workerSkillId: '',
  workerSkillDimension: defaultWorkerSkillDimension,
  workerSkillName: '',
  worker: '',
  workerEmail: '',
  course: '64b016df46559b4113eec4c9', // generalized-screening-v1
  status: ScreeningReviewQualificationSectionStatus.Pending,
  sectionTitle: 'Part 3 of 5: Response Writing (2/2)',
  questions: [questionPlaceholder],
  answers: [answerPlaceholder],
  isRewrite: false,
  rewrittenOriginalAnswers: [answerPlaceholder],
  description: "Here's the description for this question!",
  createdAt: new Date(),
};

const TaskerScreeningBenchmarkCreationTool: React.FC<TaskerScreeningBenchmarkCreationToolProps> = ({
  setNeedsFetch,
}) => {
  const [createModalOpen, setCreateModalOpen] = useState<boolean>(false);
  const [benchmark, setBenchmark] = useState<ScreeningPendingReview>(defaultBenchmark);
  const [expectedScore, setExpectedScore] = useState<number>();

  const handleScoreReview = useCallback(({ score }: { score: number }) => {
    setExpectedScore(score);
  }, []);

  const publishBenchmark = async (benchmark: ScreeningPendingReview, expectedScore: number) => {
    await API.genai.publishScreeningBenchmark({
      enabled: true,
      workerSkillDimension: benchmark.workerSkillDimension,
      workerSkillId: benchmark.workerSkillId,
      sectionTitle: benchmark.sectionTitle,
      questions: benchmark.questions,
      answers: benchmark.answers,
      isRewrite: benchmark.isRewrite,
      rewrittenOriginalAnswers: benchmark.rewrittenOriginalAnswers,
      description: benchmark.description,
      course: benchmark.course,
      expectedScore,
    });
  };

  const handlePublishBenchmark = useCallback(async () => {
    setCreateModalOpen(false);
    await publishBenchmark(benchmark, expectedScore!);
    setNeedsFetch(true);
  }, [benchmark, expectedScore, setNeedsFetch]);

  return (
    <div>
      <Button
        className="mt-4"
        variant="primary"
        onClick={() => {
          setCreateModalOpen(true);
        }}
      >
        Create Benchmark
      </Button>
      <TaskerScreeningGradingReviewModal
        review={benchmark}
        open={createModalOpen}
        setOpen={setCreateModalOpen}
        updateReviewScore={handleScoreReview}
        creatingBenchmark
        expectedScore={expectedScore}
        setReview={setBenchmark}
        publishBenchmark={handlePublishBenchmark}
      />
    </div>
  );
};

export default TaskerScreeningBenchmarkCreationTool;
